import { IpponButton, IpponHSpace, IpponText } from '@ippon-ui/react';
import {
  ELLIPSIS,
  type PaginationSlot,
  paginationSlotsOf,
} from '@/generic/pagination/domain/PaginationSlots.ts';

const PaginationSlotComponent = ({
  slot,
  currentPage,
  onPageChange,
  dataSelector,
}: {
  slot: PaginationSlot;
  currentPage: number;
  onPageChange: (page: number) => void;
  dataSelector: string;
}) => {
  if (slot === ELLIPSIS) {
    return (
      <IpponText variant="body" size="small" dataSelector={`${dataSelector}.ellipsis`}>
        …
      </IpponText>
    );
  }
  if (slot === currentPage) {
    return (
      <IpponButton size="small" disabled dataSelector={`${dataSelector}.current-page`}>
        {slot}
      </IpponButton>
    );
  }
  return (
    <IpponButton
      color="neutral"
      variant="text"
      size="small"
      onClick={() => onPageChange(slot)}
      dataSelector={`${dataSelector}.page`}
    >
      {slot}
    </IpponButton>
  );
};

export const PaginationComponent = ({
  currentPage,
  totalPages,
  onPageChange,
  dataSelector,
}: {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  dataSelector: string;
}) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <nav data-selector={dataSelector}>
      <IpponHSpace gap={8} align="middle">
        {paginationSlotsOf({ currentPage, totalPages }).map((slot, index) => (
          <PaginationSlotComponent
            key={slot === ELLIPSIS ? `ellipsis-${index}` : `page-${slot}`}
            slot={slot}
            currentPage={currentPage}
            onPageChange={onPageChange}
            dataSelector={dataSelector}
          />
        ))}
      </IpponHSpace>
    </nav>
  );
};
